import { Validator } from '@vista-digital/validator';
import { defaultUpdateMemberCredentialPromptFormConfigBase, defaultUpdatePasswordMemberCredentialPromptFormConfig, updateMemberCredentialPromptFormConfigBaseValidator, updatePasswordMemberCredentialFormConfigValidator } from './config';
import { defaultUpdateEmailMemberCredentialFormDisplayText, defaultUpdatePasswordMemberCredentialFormDisplayText, defaultUpdateUsernameMemberCredentialFormDisplayText, updateMemberCredentialPromptFormDisplayTextValidator } from './display-text';
import { updateMemberCredentialPromptFormEventsValidator } from './events';
import { UpdateMemberCredentialPromptFormFieldName } from './field-name';
const updateMemberCredentialPromptFormPropsBaseValidatorSchema = {
    displayText: updateMemberCredentialPromptFormDisplayTextValidator,
    events: updateMemberCredentialPromptFormEventsValidator
};
export const updateMemberCredentialPromptFormPropsValidator = Validator.any([
    Validator.object(Object.assign(Object.assign({}, updateMemberCredentialPromptFormPropsBaseValidatorSchema), { fieldToUpdate: Validator.isEqualTo(UpdateMemberCredentialPromptFormFieldName.Email), config: updateMemberCredentialPromptFormConfigBaseValidator })),
    Validator.object(Object.assign(Object.assign({}, updateMemberCredentialPromptFormPropsBaseValidatorSchema), { fieldToUpdate: Validator.isEqualTo(UpdateMemberCredentialPromptFormFieldName.Username), config: updateMemberCredentialPromptFormConfigBaseValidator })),
    Validator.object(Object.assign(Object.assign({}, updateMemberCredentialPromptFormPropsBaseValidatorSchema), { fieldToUpdate: Validator.isEqualTo(UpdateMemberCredentialPromptFormFieldName.Password), config: updatePasswordMemberCredentialFormConfigValidator }))
]);
const defaultUpdateEmailMemberCredentialPromptFormProps = {
    fieldToUpdate: UpdateMemberCredentialPromptFormFieldName.Email,
    config: defaultUpdateMemberCredentialPromptFormConfigBase,
    displayText: defaultUpdateEmailMemberCredentialFormDisplayText,
    events: {}
};
const defaultUpdateUsernameMemberCredentialPromptFormProps = {
    fieldToUpdate: UpdateMemberCredentialPromptFormFieldName.Username,
    config: defaultUpdateMemberCredentialPromptFormConfigBase,
    displayText: defaultUpdateUsernameMemberCredentialFormDisplayText,
    events: {}
};
const defaultUpdatePasswordMemberCredentialPromptFormProps = {
    fieldToUpdate: UpdateMemberCredentialPromptFormFieldName.Password,
    config: defaultUpdatePasswordMemberCredentialPromptFormConfig,
    displayText: defaultUpdatePasswordMemberCredentialFormDisplayText,
    events: {}
};
export const defaultUpdateMemberCredentialPromptFormPropsProvider = props => {
    switch (props.fieldToUpdate) {
        case UpdateMemberCredentialPromptFormFieldName.Email:
            return defaultUpdateEmailMemberCredentialPromptFormProps;
        case UpdateMemberCredentialPromptFormFieldName.Username:
            return defaultUpdateUsernameMemberCredentialPromptFormProps;
        case UpdateMemberCredentialPromptFormFieldName.Password:
            return defaultUpdatePasswordMemberCredentialPromptFormProps;
        default:
            return defaultUpdateEmailMemberCredentialPromptFormProps;
    }
};
//# sourceMappingURL=props.js.map